/*
 * Animated search placeholder for the header search box.
 * Types each suggestion character-by-character, holds, then moves to the next.
 * Replaces typed.js (13KB, AV false-positive) with dependency-free vanilla JS.
 */
(() => {
  const input = document.querySelector('#header__search');
  if (!input) return;

  const strings = [
    'Search for: Gothic',
    'Search for: Flames',
    'Search for: Blood',
    'Search for: Horror',
    'Search for: Skulls',
    'Search for: Death',
    'Search for: Gift Ideas'
  ];

  const TYPE_SPEED = 45;   // ms per character
  const HOLD_DELAY = 3200; // ms to show the completed string
  let stringIndex = 0;
  let charIndex = 0;
  let timer = null;
  let stopped = false;

  const tick = () => {
    if (stopped) return;
    const current = strings[stringIndex];
    if (charIndex <= current.length) {
      input.placeholder = current.slice(0, charIndex);
      charIndex += 1;
      timer = setTimeout(tick, TYPE_SPEED);
    } else {
      stringIndex = (stringIndex + 1) % strings.length;
      charIndex = 0;
      timer = setTimeout(tick, HOLD_DELAY);
    }
  };

  const stop = () => {
    stopped = true;
    clearTimeout(timer);
    input.removeAttribute('placeholder');
  };

  const start = () => {
    stopped = false;
    charIndex = 0;
    tick();
  };

  input.addEventListener('focus', stop);
  input.addEventListener('blur', () => {
    if (!input.value) start();
  });

  // small delay to avoid flashing before styles settle
  setTimeout(start, 333);
})();
